import { useNavigate } from 'react-router-dom';

import { Button, Result } from 'antd';
import { ResultStatusType } from 'antd/es/result';

interface NotFoundWithBackProps {
    backPath: string;
    backLabel?: string;
    statusCode?: ResultStatusType;
}

export function NotFoundWithBack({
    backPath,
    backLabel = 'Вернуться к списку',
    statusCode,
}: NotFoundWithBackProps) {
    const navigate = useNavigate();

    return (
        <Result
            status={statusCode || 404}
            title={statusCode == 403 ? 'Доступ запрещен' : 'Не найдено'}
            subTitle={
                statusCode == 403
                    ? 'Вы не имеете доступа к этой странице.'
                    : 'Извините, но страница, которую вы ищете, не существует или была удалена.'
            }
            extra={
                <Button type="primary" onClick={() => navigate(backPath)}>
                    {backLabel}
                </Button>
            }
        />
    );
}
